<template>
  <section class="contacts-form-section">
    <div class="contacts-form-container grid gap-[150px]">
      <div class="contacts-form-content w-[600px]">
        <div class="contacts-form-wrapper">
          <div class="contacts-form-header">
            <h2 class="contacts-form-title">{{ t('index.contactForm.title') }}</h2>
            <p class="contacts-form-subtitle">{{ t('index.contactForm.subtitle') }}</p>
          </div>
          <ContactForm @submit="handleSubmit" />
        </div>
      </div>
      <div class="contacts-form-side w-[600px]">
        <ContactInfo class="w-full"/>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import ContactInfo from '@/components/pages/contacts/ContactInfo.vue'

const { t } = useI18n()

interface ContactFormData {
  fullName: string
  email: string
  locality?: string
  region?: string
  message?: string
  privacyAccepted?: boolean
}

const handleSubmit = (data: ContactFormData) => {
  // Form submission handled by ContactForm (API + success modal)
  console.log('Form submitted:', data)
}
</script>

<style scoped>
.contacts-form-section {
  max-width: var(--max-width-container);
  margin: 0 auto;
}

.contacts-form-container {
  display: flex;
  align-items: flex-start;
  padding: 0 40px;
  min-height: 580px;
}

.contacts-form-content {
  flex: 1;
  max-width: 600px;
}

.contacts-form-wrapper {
  width: 100%;
}

.contacts-form-header {
  margin-bottom: 40px;
}

.contacts-form-title {
  font-family: var(--font-inter);
  font-weight: 600;
  font-size: 48px;
  line-height: 1.2;
  color: var(--color-dark-blue);
  margin-bottom: 16px;
}

.contacts-form-subtitle {
  font-family: var(--font-inter);
  /* font-size: var(--font-size-body); */
  line-height: 1.6;
  color: var(--color-grey);
  margin: 0;
}

.contacts-form-side {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-top: 20px;
}

@media (max-width: 1400px) {
  .contacts-form-container {
    padding: 0 60px;
  }
}

@media (max-width: 991px) {
  .contacts-form-section {
    padding: 60px 0;
  }

  .contacts-form-container {
    flex-direction: column;
    gap: 40px;
    padding: 0 30px;
  }

  .contacts-form-content {
    max-width: 100%;
  }

  .contacts-form-title {
    font-size: 36px;
  }

  .contacts-form-side {
    width: 100%;
    justify-content: flex-start;
  }
}

@media (max-width: 767px) {
  .contacts-form-section {
    padding: 40px 0;
  }

  .contacts-form-container {
    padding: 0 20px;
    gap: 50px;
  }

  .contacts-form-title {
    font-size: 28px;
  }

  .contacts-form-side {
    order: -1;
  }
}

@media (max-width: 575px) {
  .contacts-form-title {
    font-size: 24px;
  }
}

@media (max-width: 480px) {
  .contacts-form-container {
    flex-direction: column;
    padding: 0 15px;
    
  }
}
</style>
